import React, { PureComponent } from 'react';
import _ from 'lodash';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { contextKeys } from '../../../../../redux/modules/asyncRequestContexts';
import { consentActions } from '@lifeomic/phc-web-toolkit/src/redux/modules/consent';
import { bindContextKeyToSelectors } from '@lifeomic/phc-web-toolkit/src/redux/modules/asyncRequestContexts/selectors';
import { defineMessages, injectIntl } from 'react-intl';
import { asyncRequestContextsActions } from '@lifeomic/phc-web-toolkit/src/redux/modules/asyncRequestContexts';
import PropTypes from 'prop-types';
import NotificationHelper from '@lifeomic/phc-web-toolkit/src/redux/util/NotificationHelper';
import { parseConsent } from './util';
import ConsentList from './ConsentList';
import ConsentDetail from './ConsentDetail';

const consentsContextKey = contextKeys.patientViewer.fetchSubjectConsents;
const {
  isFetchingSelector: isFetchingConsentsSelector,
  responsesSelector: consentsSelector,
} = bindContextKeyToSelectors(consentsContextKey);

const messages = defineMessages({
  loadFailure: {
    id: 'patientViewer.subjectConsent.loadFailure',
    defaultMessage: "Failed to load subject's consent",
  },
});

class SubjectConsent extends PureComponent {
  state = { selectedConsent: null };

  async componentDidMount() {
    const {
      resetContext,
      fetchPatientDirectives,
      patient,
      intl: { formatMessage },
    } = this.props;

    const patientId = _.get(patient, 'id');

    if (!patientId) {
      console.error('Unable to load consents without a patient ID');
      return;
    }

    resetContext(consentsContextKey);
    const notification = new NotificationHelper(
      null,
      formatMessage(messages.loadFailure),
    );
    await fetchPatientDirectives(patientId, consentsContextKey, notification);
  }

  reloadConsents = async () => {
    const {
      resetContext,
      fetchPatientDirectives,
      patient,
      intl: { formatMessage },
    } = this.props;

    const patientId = _.get(patient, 'id');
    if (!patientId) {
      return;
    }

    resetContext(consentsContextKey);
    const notification = new NotificationHelper(
      null,
      formatMessage(messages.loadFailure),
    );
    await fetchPatientDirectives(patientId, consentsContextKey, notification);
  };

  handleConsentSelect = selectedConsent => {
    this.setState({ selectedConsent });
  };

  handleConsentClose = () => {
    this.setState({ selectedConsent: null });
  };

  handleConsentDelete = async consentId => {
    const {
      patient,
      fetchPatientDirectives,
      resetContext,
      intl: { formatMessage },
    } = this.props;

    const patientId = _.get(patient, 'id');
    if (!patientId) {
      return;
    }

    if (_.get(this.state.selectedConsent, 'id') === consentId) {
      this.setState({ selectedConsent: null });
    }

    const notification = new NotificationHelper(
      null,
      formatMessage(messages.loadFailure),
    );
    resetContext(consentsContextKey);
    await fetchPatientDirectives(patientId, consentsContextKey, notification);
  };

  render() {
    const { consents, isFetchingConsents, patient } = this.props;

    const { selectedConsent } = this.state;

    const mappedConsents = consents.map(parseConsent);
    return (
      <React.Fragment>
        <ConsentList
          patient={patient}
          listContextKey={consentsContextKey}
          data={mappedConsents}
          isFetching={isFetchingConsents}
          onConsentSelect={this.handleConsentSelect}
          onConsentDelete={this.handleConsentDelete}
          onConsentAssigned={this.reloadConsents}
        />
        {!!selectedConsent && (
          <ConsentDetail
            consent={selectedConsent}
            onClose={this.handleConsentClose}
          />
        )}
      </React.Fragment>
    );
  }
}

SubjectConsent.propTypes = {
  patient: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  resetContext: asyncRequestContextsActions.resetContext,
  fetchPatientDirectives: consentActions.fetchPatientDirectives,
};

const mapStateToProps = state => ({
  isFetchingConsents: isFetchingConsentsSelector(state),
  consents: consentsSelector(state),
});

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(SubjectConsent);
